import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { documentTransferIndex } from '../../features/dashboard/DocumentTransferSlice';
import Loading from '../../Loading';
import Broadcast from './Broadcast';
import Header from './Header';
import { ToastContainer, toast } from 'react-toastify';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import axios from 'axios';
import $ from 'jquery';
import { host } from '../../function/api'
import * as moment from 'jalali-moment';



function DocumentTransferIndex() {
    const data = useParams()
    const dispatch = useDispatch()
    const [tp_tip, setTp_tip] = useState()
    const cl_name = useRef()
    const mt_model = useRef()
    const [status, setStatus] = useState(true)
    const [documentItem, setdocumentItem] = useState({})
    const [rahpardaznetListFiles, setRahpardaznetListFiles] = useState({})
    const [MainWarehouse, setMainWarehouse] = useState('0')

    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const {
        document,
        documentTransfers,
        message,
        loading,
        update
    } = useSelector(state => state.documentTransfer)
    const { statuses } = useSelector(state => state.status)
    const rahpardaznetChangeStore = async (event) => {
        event.preventDefault()
        if(typeof documentItem.sections == 'object' && documentItem.sections.length > 0){
            if(!MainWarehouse || MainWarehouse == '0'){
                $('html, body').animate({
                    scrollTop: $(".rahpardaznet-main-warehouse").offset().top
                }, 500);
                toast.error("انبار اصلی را انتخاب کنید.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }

        }

        const data = {
            'mt_sanadno': documentItem.mt_sanadno,
            'main_warehouse': MainWarehouse
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/changeStore`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("انبار اصلی سند با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                getData()
                
                
            }

        } catch (error) {
            
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 1200,
            })
        }

    }
    const RahpardaznetShowDocuments = async (document_id) => {
        setRahpardaznetListFiles({});
        if (!document_id) {
            toast.error("فایلی بارگذاری نشده است.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }


        try {
            const HashCode = {
                'document_id': document_id
            }
            const response = await axios({
                method: 'POST',
                url: `${host}document/transfer/files`,
                data: HashCode,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            setRahpardaznetListFiles(response.data.data);
            $('.modalDocuments').trigger('click');

        } catch (error) {
            console.log(error);
        }


    }
    const getData = async () => {
        try {
            const document_id = {
                'document_id': data.document
            }
            const response = await axios({
                method: 'POST',
                url: `${host}document/electronic`,
                data: document_id,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            setdocumentItem(response.data.data);
           

        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0) {

            setMainWarehouse(documentItem.main_warehouse);



        }
    }, [documentItem])

    useEffect(() => {
        console.log(data)

        getData();
        if (update === true && status === true) {
           
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
            // message = ''
        }
    }, [update])
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    return (
        <>
            <button type="button" className="d-none modalDocuments" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalDocuments"></button>

            <div className="modal fade" id="modalDocuments">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">لیست مدارک </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <>
                                {
                                    (typeof rahpardaznetListFiles == 'object' && rahpardaznetListFiles.length > 0) ? (
                                        <>
                                            {
                                                rahpardaznetListFiles.map((file, key) => (
                                                    <div className="d-flex rahpardaznet-form-upload-file">
                                                        <div>{file.title ? file.title : 'بدون عنوان'}</div>
                                                        <div className="text-left">
                                                            <a href={"http://185.36.231.91/~rahpardaz/backend.rahpardaz.net/" + file.url} target='_blank'>دانلود فایل</a>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </>
                                    ) : (
                                        <div>موردی جهت نمایش وجود ندارد.</div>
                                    )
                                }
                            </>


                        </div>
                    </div>
                </div>
            </div>
            {loading ? (<Loading />) : ''}

            <Broadcast title={'سند الکترونیک'} />
            {
                (typeof documentItem === 'object') ? (
                    (Object.keys(documentItem).length != 0) ? (
                        <>
                            <Link to={`/dashboard/documents`} className='rahpardaznet-btn-back'>برگشت</Link>
                            <div className='row rahpardaznet-cart  my-5  print-position'>

                                <Header title='اطلاعات انبار' />
                                <div>
                                    <div className="row">
                                        <div className="col-12 col-md-8">
                                            {
                                                (typeof documentItem.sections == 'object' && documentItem.sections.length > 0) ? (


                                                    
                                                        documentItem.sections.map((section, key) => (
                                                            <>
                                                                <div className={MainWarehouse == section.section_main.id ? 'active-main-warehouse col-12 d-flex rahpardaznet-section-box' : 'section col-12 d-flex rahpardaznet-section-box'}>
                                                                    <div className='rahpardaznet-section section-main'>{section.section_main.name}</div>
                                                                    <div className='rahpardaznet-section section-one'>{section.section_one.name}</div>
                                                                    <div className='rahpardaznet-section section-two'>{section.section_two.name}</div>
                                                                    <div className='rahpardaznet-section section-three'>{section.section_three.name}</div>
                                                                </div>


                                                            </>
                                                        ))
                                                    

                                                ) : (
                                                    <div>انباری جهت نمایش وجود ندارد.</div>
                                                )
                                            }
                                        </div>
                                        <div className="col-12 col-md-4 rahpardaznet-status-title">
                                            <p>{documentItem.status_document_id ? documentItem.status_document_id : 'سند ناموجود'}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {
                                    (typeof documentItem.sections == 'object' && documentItem.sections.length > 0) ? (
                                        <div className='row rahpardaznet-cart rahpardaznet-main-warehouse  my-5  print-position'>

                                            <Header title='انبار اصلی' />
                                            <div className='rahpardaz-search-form-select'>
                                
                                                <select
                                                    value={MainWarehouse}
                                                    defaultValue={documentItem.main_warehouse}
                                                    className='form-control form-select form-select-lg shadow-none section'
                                                    onChange={(e) => setMainWarehouse(e.target.value)}
                                                >
                                                    <option value="0" disabled>انتخاب کنید ...</option>
                                                    {
                                                        documentItem.sections.map((section, key) => (
                                                            <option value={section.section_main.id}>{section.section_main.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                <button
                                                            onClick={rahpardaznetChangeStore}
                                                            type="submit"
                                                            className="print-no rahpardaznet-search-btn">
                                                           تغیر انبار

                                                        </button>
                                            </div>

                                        </div>
                                    ) : null
                                }
                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                {
                                    !documentItem.id ? (
                                        <Header title='اطلاعات کارخانه' />
                                    )
                                        : (
                                            <Header title='اطلاعات انبار' />
                                        )
                                }
                                <div className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                    <input type="hidden" value={documentItem.id} />
                                    <input type="hidden" value={documentItem.mt_sanadno} />
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <div className='d-flex flex-column justify-content-center align-items-center rahpardaznet-pelak rahpardaznet-pelak-box'>
                                            <span>{documentItem.mt_pelakserial != null ? documentItem.mt_pelakserial.replace("ایران", "") : null}</span>
                                            <span>
                                                {documentItem.mt_pelakno}
                                            </span>
                                        </div>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> تاریخ نصب : </label>
                                        <span>{documentItem.mt_pelakdate}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> شماره سند  : </label>
                                        <span>{documentItem.mt_sanadno}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label>  شرکت  : </label>
                                        <span>{documentItem.company}</span>
                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع کاربری : </label>
                                        <span>{documentItem.tp_karbari}</span>
                                    </li>

                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> سیستم : </label>
                                        <span>{documentItem.tp_system}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تیپ : </label>
                                        <span>{documentItem.tp_tip}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> رنگ : </label>
                                        <span>{documentItem.cl_name}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> مدل : </label>
                                        <span>{documentItem.mt_model}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label>  شماره بدنه  : </label>
                                        <span className="font-style">
                                            {documentItem.mt_bodyno}
                                        </span>
                                        <button type="button" className="rahpardaznet-copy-button" data-name="شماره بدنه" data-text={documentItem.mt_bodyno}>کپی</button>

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره انجین : </label>
                                        <span className="font-style">
                                            {documentItem.mt_motorno}
                                        </span>

                                        <button type="button" className="rahpardaznet-copy-button" data-name="شماره انجین" data-text={documentItem.mt_motorno}>کپی</button>

                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد محور : </label>
                                        <span>{documentItem.tp_mehvar}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد چرخ : </label>
                                        <span>{documentItem.tp_charkh}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label>  ظرفیت : </label>
                                        <span>{documentItem.tp_zarfiyat}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد سیلندر : </label>
                                        <span>{documentItem.tp_cylandr}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع سوخت : </label>
                                        <span>{documentItem.tp_sookht}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> حجم سیلندر : </label>
                                        <span>{documentItem.tp_hajm}</span>
                                    </li>
                                </div>
                            </div>



                            {
                                (documentItem.saved == "saved" && documentItem.customer_data != [] && documentItem.customer_data != null) ? (
                                    <>

                                        <div className='row rahpardaznet-cart  my-5 '>

                                            <Header title={'مشخصات مالک'} />
                                            <div className="col-7 col-md-8 p-3 list-group list-group-flush border">
                                                <li className="rahpardaznet-list-group-item pb-2 justify-content-start align-items-center d-flex">
                                                    <div> نام نام خانوادگی : </div>
                                                    <span className="px-3">{(documentItem.customer_data.name) ? documentItem.customer_data.name : ''} {(documentItem.customer_data.family) ? documentItem.customer_data.family : ''}</span>
                                                </li>

                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> نام پدر : </div>
                                                    <span className="px-3">{documentItem.customer_data.father_name}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> محل ثبت تولد : </div>
                                                    <span className="px-3">{documentItem.customer_data.birthplace}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> آدرس محل سکونت : </div>
                                                    <span className="px-3">{documentItem.customer_data.address}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div>  شماره شناسنامه / ملی: </div>
                                                    <span className="px-3">{documentItem.customer_data.nationalCode}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item  pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div>  کد پستی  : </div>
                                                    <span className="px-3">
                                                        {documentItem.customer_data.postalcode}
                                                    </span>
                                                </li>
                                            </div>
                                            <div className="col-5 col-md-4 p-3 list-group list-group-flush border">
                                                <li className="rahpardaznet-list-group-item pb-2 justify-content-start align-items-center d-flex">
                                                    <div> تاریخ ثبت/تولد : </div>
                                                    <span className="px-3">{documentItem.customer_data.birthdaye}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item  pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div>  شماره ثبت/شناسنامه: </div>
                                                    <span className="px-3">{documentItem.customer_data.idcard}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> ثبت / محل صدور : </div>
                                                    <span className="px-3">{documentItem.customer_data.placeofissue}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> تلفن ثابت : </div>
                                                    <span className="px-3">{documentItem.customer_data.phone}</span>
                                                </li>
                                                <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                    <div> شماره موبایل : </div>
                                                    <span className="px-3">
                                                        {documentItem.customer_data.mobile}
                                                    </span>
                                                </li>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className='alert alert-danger text-right'>سند فاقد مالک می باشد.</div>
                                )
                            }
                            {
                                (typeof documentItem === 'object') ? (
                                    (Object.keys(documentItem).length != 0 && typeof documentItem.transfer === 'object' && documentItem.description != null) ? (
                                        <>
                                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                                <Header title='توضیحات' />
                                                <div className='col-12'>
                                                    {documentItem.description}
                                                </div>

                                            </div>
                                        </>
                                    ) : null
                                ) : null
                            }

                            {
                                (typeof documentItem === 'object') ? (
                                    (Object.keys(documentItem).length != 0 && typeof documentItem.document_received === 'object' && documentItem.document_received != null) ? (
                                        <>
                                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                                <Header title='مدارک دریافتی' />
                                                <div className='col-12 d-grid'>
                                                    {
                                                        (documentItem.document_received.rk_certificate == 'true') ? (
                                                            <div>
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlFor="flexCheckIndeterminate">شناسنامه
                                                                    دریافت شده است.</label>
                                                            </div>
                                                        ) : null
                                                    }
                                                    {
                                                        (documentItem.document_received.rk_national_card == 'true') ? (
                                                            <div>
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlFor="rahpardaznet-national-card">کارت
                                                                    ملی دریافت شده است.</label>
                                                            </div>

                                                        ) : null
                                                    }
                                                    {
                                                        (documentItem.document_received.rk_policy == 'true') ? (
                                                            <div>
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlFor="rahpardaznet-policy">بیمه
                                                                    نامه دریافت شده است.</label>
                                                            </div>

                                                        ) : null
                                                    }
                                                    {
                                                        (documentItem.document_received.rk_residence_verification == 'true') ? (
                                                            <div>
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlFor="rahpardaznet-residence-verification">احراز
                                                                    سکونت دریافت شده
                                                                    است.</label>
                                                            </div>

                                                        ) : null
                                                    }
                                                    {
                                                        (documentItem.document_received.rk_receipt == 'true') ? (
                                                            <div>
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlFor="rahpardaznet-receipt">فیش
                                                                    قبض دریافت شده است.</label>
                                                            </div>


                                                        ) : null
                                                    }
                                                </div>

                                            </div>
                                        </>
                                    ) : null
                                ) : null
                            }


                            {
                                (typeof documentItem === 'object') ? (
                                    (Object.keys(documentItem).length != 0 && typeof documentItem.transfer === 'object' && Object.keys(documentItem.transfer).length != 0 && documentItem.transfer != null) ? (
                                        <>
                                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                                <Header title='لیست انتقال های سند' />
                                                <div className='col-12 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                                    <table className="table table-hover" style={{ direction: 'rtl' }}>
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th scope="col" className='text-center'>#</th>
                                                                <th scope="col" className='text-center'>نام مالک قبلی</th>
                                                                <th scope="col" className='text-center'>کدملی مالک قبلی</th>
                                                                <th scope="col" className='text-center'>شماره تماس مالک قبلی</th>
                                                                <th scope="col" className='text-center'>نام مالک جدید</th>
                                                                <th scope="col" className='text-center'>کدملی مالک جدید</th>
                                                                <th scope="col" className='text-center'>شماره تماس مالک جدید</th>
                                                                <th scope="col" className='text-center'>نام کارمند</th>
                                                                <th scope="col" className='text-center'>تاریخ انتقال</th>
                                                                <th scope="col" className='text-center'>عملیات</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="table-group-divider">
                                                            {
                                                                documentItem.transfer.map((transfer, key) => (
                                                                    <>
                                                                        <tr>
                                                                            <th className='text-center'>{++key}</th>
                                                                            <td className='text-center'>{(transfer.owner_details.name) ? transfer.owner_details.name : null} {(transfer.owner_details.family) ? transfer.owner_details.family : null}</td>
                                                                            <td className='text-center'>{(transfer.owner_details.nationalCode) ? transfer.owner_details.nationalCode : null}</td>
                                                                            <td className='text-center'>{(transfer.owner_details.mobile) ? transfer.owner_details.mobile : 'ثبت نشده است'}</td>
                                                                            <td className='text-center'>{(transfer.buyer_details.name) ? transfer.buyer_details.name : null} {(transfer.buyer_details.family) ? transfer.buyer_details.family : null}</td>
                                                                            <td className='text-center'>{(transfer.buyer_details.nationalCode) ? transfer.buyer_details.nationalCode : null}</td>
                                                                            <td className='text-center'>{(transfer.buyer_details.mobile) ? transfer.buyer_details.mobile : 'ثبت نشده است'}</td>
                                                                            <td className='text-center'>{(transfer.other_details.employee_name) ? transfer.other_details.employee_name : null}</td>
                                                                            <td className='text-center'>{moment(transfer.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</td>
                                                                            <td className='text-center'>
                                                                                <button type="button" className='rahpardaznet-button' onClick={(e) => RahpardaznetShowDocuments(transfer.document_id)} >مشاهده مدارک</button>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </>
                                    ) : (
                                        <div className='alert alert-warning text-right'>تاکنون انتقالی انجام نشده است.</div>
                                    )
                                ) : null
                            }


                            {
                                (typeof documentItem === 'object') ? (
                                    (Object.keys(documentItem).length != 0) ? (
                                        <>
                                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                                <Header title='پیوست ها' />
                                                <div className='col-12 col-md-6'>
                                                    <div className="rahpardaznet-list-message">

                                                        {
                                                            (typeof documentItem.DocumentNote == 'object' && documentItem.DocumentNote.length > 0) ? (
                                                                <>
                                                                    {
                                                                        documentItem.DocumentNote.map((note, key) => (
                                                                            <div
                                                                                className="message-candidate center-block">
                                                                                <div
                                                                                    className="row rahpardaznet-message-details">
                                                                                    <div
                                                                                        className="col-xs-8 col-md-6 p-0">
                                                                                        <h6 className="message-name"> {note.user_id}</h6>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                                        {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row message-text">
                                                                                    {note.description} ({note.description.length} کاراکتر)
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>
                                                            ) : (
                                                                <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                            )
                                                        }


                                                    </div>
                                                </div>
                                                <div className='col-12 col-md-6'>
                                                    {
                                                        (typeof documentItem.documentFile == 'object' && documentItem.documentFile.length > 0) ? (
                                                            <>
                                                                {
                                                                    documentItem.documentFile.map((file, key) => (
                                                                        <div className="d-flex rahpardaznet-form-upload-file">
                                                                            <div>{file.title ? file.title : 'بدون عنوان'} ({moment(file.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')})</div>
                                                                            <div className="text-left">
                                                                                <a href={"http://185.36.231.91/~rahpardaz/backend.rahpardaz.net/" + file.url} target='_blank'>دانلود فایل</a>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </>
                                                        ) : (
                                                            <div>موردی جهت نمایش وجود ندارد.</div>
                                                        )
                                                    }
                                                </div>

                                            </div>
                                        </>
                                    ) : null
                                ) : null
                            }






                            {
                                (typeof documentItem === 'object') ? (
                                    (Object.keys(documentItem).length != 0) ? (
                                        <>
                                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                                <Header title='گزارشات' />
                                                <div className='col-12 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                                    <table className="table table-hover" style={{ direction: 'rtl' }}>
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th scope="col" className='text-center'>#</th>
                                                                <th scope="col" className='text-center'>نام کارمند</th>
                                                                <th scope="col" className='text-center'>تاریخ</th>
                                                                <th scope="col" className='text-center'>پیغام</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="table-group-divider">
                                                            {
                                                                documentItem.log.map((log, key) => (
                                                                    <>
                                                                        <tr>
                                                                            <td className='text-center'>{++key}</td>
                                                                            <td className='text-center'>{log.userProfile.name}</td>
                                                                            <td className='text-center'>{moment(log.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</td>
                                                                            <td className='text-center'>{log.title}</td>
                                                                        </tr>
                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </>
                                    ) : null
                                ) : null
                            }
                        </>
                    ) : <Loading />
                ) : (
                    <Loading />
                )
            }
        </>

    )

}

export default DocumentTransferIndex;